/* eslint-disable react/jsx-no-useless-fragment */
import React from "react";
import { FormControl, FormLabel } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { Combobox } from "@repo/ui";

export default function ReactHookFormDropdown({
  label,
  name,
  isRequired,
  placeholder,
  rules,
  info,
  data,
  disabled,
  errors,
  controlStyles,
  control,
  onChange,
}) {
  const handleValueChange = (selectedValue, fieldValue, fieldOnChange) => {
    const isSameValue = fieldValue === selectedValue;
    const newValue = isSameValue ? null : selectedValue;
    onChange?.(newValue);
    fieldOnChange(newValue);
  };

  return (
    <FormControl
      isRequired={Boolean(isRequired)}
      style={controlStyles ? controlStyles : {}}
    >
      <FormLabel>{label}</FormLabel>
      <Controller
        control={control}
        name={name}
        rules={rules || {}}
        render={({ field }) => {
          return (
            <Combobox
              disabled={disabled}
              className={errors[name] ? "error-field" : ""}
              value={field.value || null}
              data={data || []}
              placeholder={placeholder}
              setValue={(res) =>
                handleValueChange(res, field.value, field.onChange)
              }
            />
          );
        }}
      />
      {info ? (
        <p className="text-sm text-gray-500 mt-1 italic">{info || ""}</p>
      ) : (
        <></>
      )}

      {errors[name] ? (
        <p className="text-sm text-red-500 mt-1">
          {errors[name].message || "Please Select Field!"}
        </p>
      ) : (
        <></>
      )}
    </FormControl>
  );
}
